'use client'

import { NavContext } from "@/context/navContext"
import api from "@/util/api"
import { useContext, useEffect, useState } from "react"
import VerifiedRankListComponent from "../float/verified_right"
import ListV2 from "@/components/board/list_v2"
import BoardListInfo from "@/components/etc/boardListInfo"
import { AuthContext } from "@/context/authContext"
import { SettingContext } from "@/context/siteContext"
import { with_comma } from "@/util/comma"
import { FloatContext } from "@/context/moFloatMenuContext"
import { DeviceContext } from "@/context/deviceContext"
import { usePathname, useRouter } from "next/navigation";
import useUser from "@/hooks/useUser"
import { useTranslations } from "next-intl"


interface verifiedRankData {
    id: number,
    name: string,
    rank_info: verifiedRankListType[]
}
interface verifiedRankListType {
    create_dt: string,
    id: number,
    rank: number,
    site: string,
    verifiedsite_logo:string
}

export default function VerifiedFavoriteList({ setActive, className }: { setActive: Function, className?:string }) {
    const [list, setList] = useState<verifiedRankData[]>([])
    const { movePage } = useContext(NavContext)
    const [loading, setLoading] = useState<boolean>(true)
    const { user, userUpdate } = useContext(AuthContext)
    const { setUser  } = useUser()
    const { setting } = useContext(SettingContext);
    const { mypageShow, SetMypageShow } = useContext(FloatContext)
    const { mobileMode } = useContext(DeviceContext)
    const router = useRouter()

    const t = useTranslations("Text")

    useEffect(() => {
        console.log("즐찾", user);
        if (!user.is_authenticated) {
            router.push("/")   
        }
    }, [user, router])
    if (!user.is_authenticated) return null;

    function fetchData(){
        setLoading(true)
        api(`/api/verified/list/?is_favorited=true`)
            .then(res=> res.json())
            .then(({data, status_code})=> {
                // console.log("data.objects", data.objects)
                // console.log("********status_code", status_code)

                if(status_code != 200 ){
                    userUpdate({is_authenticated: false })
                    location.reload();
                    return;
                }

                setList(Array.isArray(data?.objects) ? data.objects : [])
                setLoading(false)
            })
            .catch((err) => {
                userUpdate({ is_authenticated: false })
                location.reload();
            })
    }
    
    function setContent(id:number){
        // console.log("id", id)
        movePage(`/verified/company/?id=${id}`)
        SetMypageShow(false)

    }

    function setFavorite(el: HTMLElement, id:number) {
        api(`/api/verified/favorites/${id}/`, { method: "POST" })
            .then(res => res.json())
            .then(({data}) => {
                if(el && data?.is_favorited){
                    el.classList.toggle("active", data.is_favorited === true);
                }
                fetchData();

            })
            .catch((error: Response) =>{
// console.log(error)
            })
            
    }
    useEffect(()=> {
        fetchData();
    },[mypageShow])

    


    return (
        <>
            {list.length > 0 && 
            <>
            <div className={`mypage_title m-b-1 m-t-30`}>{t("즐겨찾기")}</div>
            <div className={`mypage_box`}>
                <ListV2 list={list} 
                        setContent={setContent} 
                        className={`verified-list-container-new ${className}`}
                        showEmptyText={false}
                        loading={loading}>
                    {(item: any, idx: number) => (
                        <>
                        
                        {user.is_authenticated &&
                        <div className={`favoritesArea ${item.is_favorited ? "active":""}`}
                                onClick={(e)=>{
                                    e.stopPropagation();  
                                    setFavorite(e.currentTarget, item.id)
                                }}></div>
                        }
                        <div className={`img`}>
                            <img src={item.verifiedsite_image} alt={item.title} />
                        </div>
                        <div className={`box`}>
                            
                            {!mobileMode &&
                            <div className={`font-12 m-b-4  ${!mobileMode ? "p-b-5" : ""}`}
                                style={mobileMode ? {margin:"4px 0 0", textAlign:"center"} :{}}>
                                    [{setting?.objects[0].content}] {t("공식 스폰업체")}
                            </div>
                            }
                            
                            <div className={`title`}>
                                {mobileMode ? item.site_name : item.title}
                            </div>
                            
                            {!mobileMode &&
                            <>

                                <div className={`listInfo`}>
                                    <BoardListInfo 
                                        // comment={999}
                                        thumbs={with_comma(item.likes)} />
                                </div>
                            </>
                            }
                        </div>
                        </>
                    )}
                </ListV2>
            </div>
            </>
            }
        </>
    )
}